import sensors from "sa-sdk-javascript";
import { TRACK_TYPE } from "@zhihaoscm/meta";

const ACCESS_TIME_KEY = "accessTime";
let initialized = false;

/** 初始化与 Vue 相同的神策端点和采集选项。 */
export function initializeTelemetry() {
    if (initialized || import.meta.env.MODE === "test") return;
    initialized = true;
    const serverUrl = import.meta.env.DEV
        ? "http://localhost:7006/dataService/tracking-point/sensors/collect"
        : `${new URL(import.meta.env.VITE_API_URL).origin}/dataService/tracking-point/sensors/collect`;
    sensors.registerPage({ client_type: 1 });
    sensors.init({
        server_url: serverUrl,
        is_track_single_page: false,
        use_client_time: true,
        send_type: "beacon",
        heatmap: { clickmap: "not_collect", scroll_notice_map: "not_collect" },
        show_log: true
    });
    if (!localStorage.getItem(ACCESS_TIME_KEY)) localStorage.setItem(ACCESS_TIME_KEY, Date.now().toString());
    window.addEventListener("storage", restoreAccessTime);
    window.addEventListener("beforeunload", trackPageStay);
}

function restoreAccessTime(event: StorageEvent) {
    if (event.key === ACCESS_TIME_KEY && !localStorage.getItem(ACCESS_TIME_KEY)) {
        localStorage.setItem(ACCESS_TIME_KEY, String(Date.now()));
    }
}

function trackPageStay() {
    const startedAt = localStorage.getItem(ACCESS_TIME_KEY);
    localStorage.removeItem(ACCESS_TIME_KEY);
    if (!startedAt) return;
    sensors.track("145", {
        pageDesc: "系统",
        sceneText: "页面停留事件",
        event_duration: (Date.now() - Number(startedAt)) / 1000,
        type: TRACK_TYPE.PAGE_STAY_DURATION.code
    });
}

/** 登录用户更新后注册 customer_id，与 Vue userStore.setUserInfo 一致。 */
export function registerTelemetryUser(customerId?: number) {
    if (customerId) sensors.registerPage({ customer_id: customerId });
}

